import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import Onboarding from "@/pages/Onboarding";
import PaymentResult from "@/pages/PaymentResult";
import Admin from "@/pages/Admin";
import VerifyLicense from "@/pages/VerifyLicense";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<Legal kind="privacy" />} />
        <Route path="/terms-of-use" element={<Legal kind="terms" />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/payment/success" element={<PaymentResult kind="success" />} />
        <Route path="/payment/cancel" element={<PaymentResult kind="cancel" />} />
        <Route path="/verify" element={<VerifyLicense />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
